(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "a42ec67c7f3523bb633aebb11d62eb90336c5338"
};